export default {
  'button.add': '添加',
  'button.edit': '编辑',
  'button.delete': '删除',
  'button.search': '查询',
  'button.reset': '重置',
  'button.confirm': '确认',
  'button.cancel': '取消',
  'button.back': '返回',
  'button.save': '保存',
  'button.view': '查看',
  'button.export': '导出',
  'button.import': '导入',
  'button.refresh_policies': '刷新权限',
};
